import { renderTemplate, SB } from '@play-co/replicant';
import {
  androidGenericTemplate,
  iosGenericTemplate,
} from '../messageTemplates';
import { getPetAssetKey, speciesChatbot } from '../flex/species';
import { buildSender } from '../sender';

/**
 * Simple chatbot message with quick reply options
 *
 * @see https://developers.line.biz/en/docs/messaging-api/using-quick-reply/
 */
export const quickReplyChatbotMessage = {
  quickReply: renderTemplate({
    args: SB.object({
      message: SB.string(),
      species: SB.tuple(speciesChatbot),
      petName: SB.string(),
      select: SB.array(SB.string()),
    }),
    renderers: {
      line: ({ args, api }) => {
        const { species, message, petName } = args;

        const options = args.select.map((option) => ({
          type: 'action',
          action: {
            type: 'message',
            label: option,
            text: option,
          },
        }));

        return {
          type: 'text',
          text: message,
          sender: buildSender({
            name: petName,
            iconUrl: api.getAssetPath(getPetAssetKey(species)),
          }),
          quickReply: {
            items: options,
          },
        };
      },
      ios: ({ args, payload }) =>
        iosGenericTemplate({
          alert: args.message,
          payload,
        }),
      android: ({ args, payload }) =>
        androidGenericTemplate({
          title: args.message,
          payload,
        }),
    },
  }),
};
